/* BRINUTI termékkép-nagyító
 *
 * Két esetet kell kiszolgálnia:
 *
 * 1) Sima termékek (Toll, Ajándékdoboz — alap product sablon)
 *    A galériában valódi <img> elemek vannak. Ezeket nagyítjuk, a Shopify CDN
 *    width paraméterével nagyobb változatot kérve.
 *
 * 2) Teeinblue naplók (product.teeinblue_termekek sablon)
 *    Itt a látható kép NEM egyetlen <img>, hanem rétegekből összerakott
 *    kompozíció: .tee-mockup-item > .tee-mockup > (.tee-mockup-image +
 *    .tee-printarea--image ...). Ha csak a mögötte lévő <img>-et nagyítanánk,
 *    a személyre szabott grafika nélküli alap mockup jelenne meg. Ezért itt a
 *    teljes réteg-kompozíciót klónozzuk és CSS transform-mal nagyítjuk fel,
 *    így a rányomtatott monogram is a helyén marad.
 *
 * A Horizon saját nagyítója (zoom-dialog) ki van kapcsolva a termék-sablonokban
 * (media-gallery blokk "zoom" beállítása), különben egy láthatatlan, teljes
 * méretű gomb fogná el a kattintást a kép előtt.
 */
(function () {
  'use strict';

  var GALLERY_SELECTOR = '.product-information__media';
  var TEE_ITEM_SELECTOR = '.tee-mockup-item';
  var MIN_MAIN_IMAGE_WIDTH = 250;
  var ZOOM_WIDTH = 1800;
  var FILL_HEIGHT = 0.9; // a képernyő magasságának ekkora részét töltse ki
  var FILL_WIDTH = 0.92;

  var overlay = null;
  var overlayImg = null;
  var overlayStage = null;
  var counterEl = null;
  var prevBtn = null;
  var nextBtn = null;
  var slides = []; // { type: 'image' | 'composite', node: Element }
  var current = 0;

  function hiRes(src) {
    if (!src) return src;
    try {
      var u = new URL(src, window.location.href);
      var isShopify = /cdn\.shopify\.com$/.test(u.hostname) || /\/cdn\/shop\//.test(u.pathname);
      if (u.searchParams.has('width') || isShopify) {
        u.searchParams.set('width', String(ZOOM_WIDTH));
        return u.toString();
      }
      return src;
    } catch (e) {
      return src;
    }
  }

  function isMainImage(img) {
    if (!img || img.tagName !== 'IMG') return false;
    if (img.closest('.dialog-thumbnails-list') || img.closest('[class*="thumbnail"]')) return false;
    if (img.closest(TEE_ITEM_SELECTOR)) return false; // ezt a kompozíció kezeli
    return img.getBoundingClientRect().width >= MIN_MAIN_IMAGE_WIDTH;
  }

  function collect(gallery) {
    slides = [];

    // korábbi jelölések törlése, hogy ne maradjon zoom-in kurzor olyan elemen,
    // amit a Teeinblue időközben lecserélt
    var stale = document.querySelectorAll('.brinuti-zoomable');
    for (var s = 0; s < stale.length; s++) stale[s].classList.remove('brinuti-zoomable');

    // Teeinblue kompozíciók elsőbbséget élveznek: ha vannak, a sima képek
    // mögöttük az alap mockupok, azokat nem akarjuk külön felkínálni.
    var tee = gallery.querySelectorAll(TEE_ITEM_SELECTOR);
    for (var t = 0; t < tee.length; t++) {
      if (tee[t].getBoundingClientRect().width >= MIN_MAIN_IMAGE_WIDTH) {
        slides.push({ type: 'composite', node: tee[t] });
        tee[t].classList.add('brinuti-zoomable');
      }
    }
    if (slides.length) return;

    var imgs = gallery.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (isMainImage(imgs[i])) {
        slides.push({ type: 'image', node: imgs[i] });
        imgs[i].classList.add('brinuti-zoomable');
      }
    }
  }

  function build() {
    if (overlay) return;

    overlay = document.createElement('div');
    overlay.className = 'brinuti-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Termékkép nagyítva');

    overlayImg = document.createElement('img');
    overlayImg.className = 'brinuti-zoom__image';
    overlayImg.alt = '';

    overlayStage = document.createElement('div');
    overlayStage.className = 'brinuti-zoom__stage';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'brinuti-zoom__close';
    closeBtn.setAttribute('aria-label', 'Bezárás');
    closeBtn.innerHTML = '&times;';

    prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'brinuti-zoom__nav brinuti-zoom__nav--prev';
    prevBtn.setAttribute('aria-label', 'Előző kép');
    prevBtn.innerHTML = '&#8249;';

    nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'brinuti-zoom__nav brinuti-zoom__nav--next';
    nextBtn.setAttribute('aria-label', 'Következő kép');
    nextBtn.innerHTML = '&#8250;';

    counterEl = document.createElement('div');
    counterEl.className = 'brinuti-zoom__counter';

    overlay.appendChild(overlayImg);
    overlay.appendChild(overlayStage);
    overlay.appendChild(closeBtn);
    overlay.appendChild(prevBtn);
    overlay.appendChild(nextBtn);
    overlay.appendChild(counterEl);
    document.body.appendChild(overlay);

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    overlayImg.addEventListener('click', close);
    overlayStage.addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
  }

  function showImage(node) {
    overlayStage.hidden = true;
    overlayStage.innerHTML = '';
    overlayImg.hidden = false;
    overlayImg.src = hiRes(node.currentSrc || node.src);
    overlayImg.alt = node.alt || '';
  }

  function showComposite(node) {
    overlayImg.hidden = true;
    overlayImg.removeAttribute('src');
    overlayStage.hidden = false;
    overlayStage.innerHTML = '';

    var rect = node.getBoundingClientRect();
    var w = rect.width || 1;
    var h = rect.height || 1;
    var scale = Math.min(
      (window.innerHeight * FILL_HEIGHT) / h,
      (window.innerWidth * FILL_WIDTH) / w
    );

    var clone = node.cloneNode(true);
    clone.classList.remove('brinuti-zoomable');
    clone.style.width = w + 'px';
    clone.style.height = h + 'px';
    clone.style.margin = '0';

    // A klónt az eredeti méretén tartjuk, és egyben nagyítjuk, hogy a
    // rétegek egymáshoz képesti helyzete ne csússzon el.
    overlayStage.style.width = Math.round(w * scale) + 'px';
    overlayStage.style.height = Math.round(h * scale) + 'px';

    var inner = document.createElement('div');
    inner.className = 'brinuti-zoom__composite';
    inner.style.width = w + 'px';
    inner.style.height = h + 'px';
    inner.style.transform = 'scale(' + scale + ')';
    inner.appendChild(clone);
    overlayStage.appendChild(inner);
  }

  function show(index) {
    if (!slides.length) return;
    current = (index + slides.length) % slides.length;
    var slide = slides[current];
    if (slide.type === 'composite') showComposite(slide.node);
    else showImage(slide.node);

    var many = slides.length > 1;
    prevBtn.hidden = !many;
    nextBtn.hidden = !many;
    counterEl.textContent = many ? (current + 1) + ' / ' + slides.length : '';
  }

  function step(delta) {
    show(current + delta);
  }

  function open(index) {
    build();
    show(index);
    overlay.classList.add('is-open');
    document.body.classList.add('brinuti-zoom-open');
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('brinuti-zoom-open');
    overlayStage.innerHTML = '';
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  }

  function init() {
    // A figyelő a DOKUMENTUMRA kerül, nem a galériára: a Teeinblue újrarajzoláskor
    // kicseréli a galéria DOM-csomópontját, és egy arra kötött figyelő a leváló
    // elemmel együtt elveszne. (Ettől működött elsőre, majd többé nem.)
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      var gallery = e.target.closest(GALLERY_SELECTOR);
      if (!gallery) return;

      collect(gallery); // a Teeinblue menet közben újrarajzolhat

      // 1) Teeinblue kompozíció
      var tee = e.target.closest(TEE_ITEM_SELECTOR);
      var index = -1;
      if (tee) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].node === tee) { index = i; break; }
        }
      } else {
        // 2) sima kép
        var img = e.target.closest('img');
        if (img && isMainImage(img)) {
          for (var j = 0; j < slides.length; j++) {
            if (slides[j].node === img) { index = j; break; }
          }
        }
      }
      if (index === -1) return;

      e.preventDefault();
      e.stopPropagation();
      open(index);
    }, true);

    // A nagyítható elemek megjelölése (zoom-in kurzor). Ugyanezért figyeljük a
    // body-t és nem a galériát: az a csomópont cserélődhet.
    var pending = null;
    function mark() {
      var g = document.querySelector(GALLERY_SELECTOR);
      if (g) collect(g);
    }
    var observer = new MutationObserver(function () {
      if (pending) clearTimeout(pending);
      pending = setTimeout(mark, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    mark();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
